import React, { useState, useEffect } from 'react'
import 'antd/lib/select/style/index.css'
import { Card, CardBody, Col, Row } from "reactstrap"
import { Pagination, message, Select, Checkbox } from "antd"
import { SearchOutlined } from '@ant-design/icons'
import { Link } from "react-router-dom"
import SearchTagBrand from './filter/SearchTagBrand'
import FilterSelect from './filter/FilterSelect'
import TagBrandTable from './table/TagBrandTable'
import { getListTagBrand, getExportTagBrands } from '../../../services/api/apiBrands'
import UseDebounce from './helpers/UseDebounce'
import moment from 'moment'

const BRAND_TYPE = [
    {
        name: 'Branding',
        value: 'branding'
    },
    {
        name: 'Packaging',
        value: 'packaging'
    }
]


const TagBrandPage = () => {

    const [limit, setLimit] = useState(20)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [error, setError] = useState('')
    const [typeBrand, setTypeBrand] = useState('')
    const [fieldSearch, setFieldSearch] = useState('store')
    const [valueSearch, setValueSearch] = useState('')
    const [listTagBrand, setListTagBrand] = useState([])
    const [materialCode, setMaterialCode] = useState([])
    const [materialSearch, setMaterialSearch] = useState('')
    const [brandDetail, setBrandDetail] = useState([])
    const [brandSearch, setBrandSearch] = useState('')
    const [listMaterialCode, setListMaterialCode] = useState([])
    const [listBrandDetails, setListBrandDetails] = useState([])
    const [status, setStatus] = useState('')
    const [stockAlert, setStockAlert] = useState(false)

    const deBounceValueSearch = valueSearch === '' ? UseDebounce(valueSearch, 0) : UseDebounce(valueSearch, 500)

    const handlePageChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _handleChangeFieldSeach = field => {
        setFieldSearch(field)
        setValueSearch('')
    }

    const _hanldeChangeValueSearch = value => {
        setValueSearch(value)
        setPage(1)
    }

    const _handleChangeBrandType = typeBrand => {
        setTypeBrand(typeBrand)
        setPage(1)
    }

    const _fetchListTagBrand = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page,
                limit
            }

            if (typeBrand) payload.type = typeBrand
            if (valueSearch) {
                if (fieldSearch === 'store') payload.store = valueSearch
                if (fieldSearch === 'brand_name') payload.brandName = valueSearch
            }
            if(materialCode.length > 0) payload.materialCodes = materialCode
            if(brandDetail.length > 0) payload.brandDetails = brandDetail
            if(status) payload.isActive = status==='active' ? 1 : 0
            if(stockAlert) payload.stockAlert = 1

            const { data } = await getListTagBrand(payload)
            const { success, message, data: res } = data

            if (!success) return setError(message)

            const { brandTags, total , materialCodes, brandDetails } = res

            setListTagBrand(brandTags)
            setListMaterialCode(materialCodes)
            setListBrandDetails(brandDetails)
            setTotal(total)


        } catch (e) {
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    const handleExportBatch = async() => {
        try {
            const payload = {
                page,
                limit,
            }
            
            if (typeBrand) payload.type = typeBrand
            if (valueSearch) {
                if (fieldSearch === 'store') payload.store = valueSearch
                if (fieldSearch === 'brand_name') payload.brandName = valueSearch
            }
            if(materialCode.length > 0) payload.materialCodes = materialCode
            if(brandDetail.length > 0) payload.brandDetails = brandDetail
            if(status) payload.isActive = status==='active' ? 1 : 0
            if(stockAlert) payload.stockAlert = 1

            const response = await getExportTagBrands(payload)
            if(response){
                const {success, message: mess, data} = response
                if(success==='false'){
                    message.error(mess)
                }else{
                    let csvFile
                    let downloadLink
                    const start = moment(Date.now()).format('YYYY/MM/DD')
                    csvFile = new Blob(['\uFEFF' + data], { type: 'text/csv;encoding:utf-8' })
                    downloadLink = document.createElement('a')
                    downloadLink.download = `TagBrands_${start}`
                    downloadLink.href = window.URL.createObjectURL(csvFile)
                    downloadLink.style.display = 'none'
                    document.body.appendChild(downloadLink)
                    downloadLink.click()
                    document.body.removeChild(downloadLink)
                    message.success('Dữ liệu đã được export!')
                }
            }else{
                message.error('Dữ liệu chưa được export!')
            }
        } catch (e) {
            alert(e.toString())
        }

    }
    
    const _handleChangeMaterialCode = Code => {
        setMaterialSearch('')
        setMaterialCode(Code)
        setPage(1)
    }

    const handleSearchMaterialCode = (value) => {
        if (value && value.includes(',')) {
            const newValue = [...new Set([...value.replace(/ /g, ',').split(',').map(i => i.trim()).filter(i => i), ...materialCode])]
            setMaterialCode(newValue)
            setMaterialSearch('')
        } else return setMaterialSearch(value)
    }

    const _handleChangeBrandDetail= brand => {
        setBrandSearch('')
        setBrandDetail(brand)
        setPage(1)
    }

    const handleSearchBrandDetail = (value) => {
        if (value && value.includes(',')) {
            const newValue = [...new Set([...value.replace(/ /g, ',').split(',').map(i => i.trim()).filter(i => i), ...brandDetail])]
            setBrandDetail(newValue)
            setBrandSearch('')
        } else return setBrandSearch(value)
    }

    const _handleChangeStatus = status => {
        setStatus(status)
        setPage(1)
    }

    const _handleChangeStockAlert = e => {
        const check = e.target.checked
        setStockAlert(check)
        setPage(1)
    }

    useEffect(() => {
        _fetchListTagBrand()
    }, [limit, page, typeBrand, deBounceValueSearch, materialCode, brandDetail, status, stockAlert])

    const materialCodeOptions = listMaterialCode && listMaterialCode.length > 0 ? listMaterialCode.map((i, index) => ({
        label: i,
        value: i,
    })) : []
    const brandDetailsOptions = listBrandDetails && listBrandDetails.length > 0 ? listBrandDetails.map((i,index)=> ({
        label: i,
        value: i,
    })) : []
    const statusOptions = [
        {label: 'Active', value: 'active'},
        {label: 'Deactive', value: 'deactive'},
    ]

    if (error) return <span className='text-danger'>{error}</span>

    return (
        <div className='TagBrandPage'>
            <Card>
                <div className="CardHeader card-header header-elements-inline">
                    <div className="header-elements d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex flex-column">
                            <div className="ReturnPage mb-2">
                                <Link to={'/brands-rule'} className="txt-16">
                                    <i className="fa fa-chevron-left mr-2" /> List brands rule
                                </Link>
                            </div>
                            <h1 className='card-title'>Tag Brands Inventory Management</h1>
                        </div>
                        <div className="actions">
                        <button
                            className='btn btn-primary mr-2'
                            onClick={handleExportBatch}
                        >
                            <i className="fa fa-download mr-1"/>Export
                        </button>

                            <Link to="/tag-brand-new" className="btn btn-primary">
                                Add tag brands
                            </Link>
                        </div>
                    </div>
                </div>
                <CardBody>
                    <div className="TagBrandFilters mb-3 p-3">
                        <Row form>
                            <Col md={4} className="mr-2">
                                <SearchTagBrand
                                    handleChangeFieldSeach={_handleChangeFieldSeach}
                                    hanldeChangeValueSearch={_hanldeChangeValueSearch}
                                    valueSearch={valueSearch}
                                    fieldSearch={fieldSearch}
                                    placeholders={{
                                        store: "store",
                                        brand_name: "brand name",
                                        brand_type: "brand type"
                                    }}
                                />
                            </Col>
                            <Col md={1} className="mr-2">
                                <FilterSelect
                                    options={BRAND_TYPE}
                                    placeholder="-- Brand type"
                                    onChangeSelect={_handleChangeBrandType}
                                />
                            </Col>
                            <Col md={2} className="mr-2">
                                <Select
                                    mode='tags'
                                    allowClear
                                    options={materialCodeOptions}
                                    placeholder="Search Material code"
                                    onChange={_handleChangeMaterialCode}
                                    showArrow
                                    showSearch
                                    value={materialCode || []}
                                    style={{ width: '100%' }}
                                    suffixIcon={<SearchOutlined />}
                                    onSearch={handleSearchMaterialCode}
                                    searchValue={materialSearch}
                                />
                            </Col>
                            <Col md={2} className="mr-2">
                                <Select
                                    mode='tags'
                                    allowClear
                                    options={brandDetailsOptions}
                                    placeholder="Search Brand detail"
                                    onChange={_handleChangeBrandDetail}
                                    showArrow
                                    showSearch
                                    value={brandDetail || []}
                                    style={{ width: '100%' }}
                                    suffixIcon={<SearchOutlined />}
                                    onSearch={handleSearchBrandDetail}
                                    searchValue={brandSearch}
                                />
                            </Col>
                            <Col md={1} className="mr-2">
                                <Select
                                    allowClear
                                    options={statusOptions}
                                    placeholder="-- Status"
                                    onChange={_handleChangeStatus}
                                    showArrow
                                    value={status || []}
                                    style={{ width: '100%' }}
                                />
                            </Col>
                            <Col md={1} className='mr-2 d-flex align-items-center'>
                                <label className='mb-0 mr-1'>Stock alert</label>
                                <Checkbox value={stockAlert} onChange={_handleChangeStockAlert}/>
                            </Col>
                        </Row>
                    </div>

                    <div className="d-flex justify-content-end mb-3">
                        <div className='d-flex align-items-center justify-content-end'>
                            <div className='d-flex align-items-center ml-3'>
                                <div className='ml-3'>Total: <span className='font-weight-bold'>{total || 0}</span></div>
                            </div>
                        </div>
                    </div>

                    <TagBrandTable
                        listTagBrand={listTagBrand}
                        loading={loading}
                        error={error}
                        reset={_fetchListTagBrand}
                    />

                    <Pagination
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        className='text-right mt-3'
                        pageSize={limit}
                        showSizeChanger
                        current={page}
                        total={total}
                    />

                </CardBody>
            </Card>
        </div>
    )
}

export default TagBrandPage